import { DASHBOARDS_ROUTE_SEGMENT, EDITOR_SEGMENT, NEW_DASHBOARD_SEGMENT } from '../../constants';

/**
 * Which of the section's four screens a path is, for the skeleton that has to
 * look like it before its chunk has loaded. Same segments the router builds its
 * paths from (`router.tsx` already imports them eagerly, so this adds nothing to
 * the initial bundle).
 *
 * | Path                       | Kind     |
 * |----------------------------|----------|
 * | `dashboards/new`           | `create` |
 * | `dashboards/new/editor`    | `editor` |
 * | `dashboards/:id`           | `view`   |
 * | `dashboards/:id/editor`    | `editor` |
 *
 * Anchored to `/accounts/:accountId/dashboards/…` and to the end of the path:
 * the section lives under an account and nowhere else (see `router.tsx`).
 */
export type DashboardSkeletonKind = 'create' | 'editor' | 'view';

const DASHBOARD_PATH = new RegExp(
  `^/accounts/[^/]+/${DASHBOARDS_ROUTE_SEGMENT}/([^/]+)(/${EDITOR_SEGMENT})?/?$`,
);

export function dashboardSkeletonKind(pathname: string): DashboardSkeletonKind | null {
  const match = DASHBOARD_PATH.exec(pathname);
  if (!match) return null;

  const [, dashboard, editor] = match;
  if (editor) return 'editor';
  return dashboard === NEW_DASHBOARD_SEGMENT ? 'create' : 'view';
}
